import React from 'react'

export default function Record() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_5931_5806)">
        <path d="M6.125 8.82875L4.55437 7.25813L3.9375 7.875L6.125 10.0625L10.0625 6.125L9.44563 5.50375L6.125 8.82875Z" fill="#03555E" />
        <path d="M10.9375 2.1875H9.625V1.75C9.625 1.51794 9.53281 1.29538 9.36872 1.13128C9.20462 0.967187 8.98206 0.875 8.75 0.875H5.25C5.01794 0.875 4.79538 0.967187 4.63128 1.13128C4.46719 1.29538 4.375 1.51794 4.375 1.75V2.1875H3.0625C2.83044 2.1875 2.60788 2.27969 2.44378 2.44378C2.27969 2.60788 2.1875 2.83044 2.1875 3.0625V12.25C2.1875 12.4821 2.27969 12.7046 2.44378 12.8687C2.60788 13.0328 2.83044 13.125 3.0625 13.125H10.9375C11.1696 13.125 11.3921 13.0328 11.5562 12.8687C11.7203 12.7046 11.8125 12.4821 11.8125 12.25V3.0625C11.8125 2.83044 11.7203 2.60788 11.5562 2.44378C11.3921 2.27969 11.1696 2.1875 10.9375 2.1875ZM5.25 1.75H8.75V3.5H5.25V1.75ZM10.9375 12.25H3.0625V3.0625H4.375V4.375H9.625V3.0625H10.9375V12.25Z" fill="#03555E" />
      </g>
      <defs>
        <clipPath id="clip0_5931_5806">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
